export default __webpack_public_path__ + "static/media/4. repse.4d621832.png";